import { defineMessages } from 'react-intl';
import * as Actions from '../../../create-label-content/create-label-content.actions';

const messages = defineMessages({
  createAndPrintLabel: {
    description: 'cswPrimaryActions.createAndPrintLabel',
    defaultMessage: 'Create + Print Label',
    id: 'HWc2K7',
  },
});

export const createAndPrintLabel = {
  id: 'createAndPrintLabel',
  translation: messages.createAndPrintLabel,

  getActionFromFulfillmentPlanId: (fulfillmentPlanId, labelMetadata) => {
    return Actions.createLabel({
      fulfillmentPlanId,
      doNotPrint: false,
      labelMetadata,
    });
  },
};
